export const reconnectMessageVisible = (startedAt: number | null, now = Date.now(), delay = 5_000): boolean => startedAt !== null && now - startedAt >= delay;
